import { useQuery } from '@tanstack/react-query';
import { fetchActivityLog, fetchWorkOrderActivity } from '@/services/activityLogService';

export function useActivityLog(entityType?: string, entityId?: string) {
  return useQuery({
    queryKey: ['activity-log', entityType, entityId],
    queryFn: () => fetchActivityLog(entityType, entityId),
    enabled: !!entityType && !!entityId,
  });
}

export function useWorkOrderActivity(workOrderId: string | undefined, assetIds: string[] = []) {
  return useQuery({
    queryKey: ['activity-log', 'work-order', workOrderId],
    queryFn: () => fetchWorkOrderActivity(workOrderId!, assetIds),
    enabled: !!workOrderId,
  });
}
